module.exports = __webpack_public_path__ + "static/image_10_thumb-af1763266ff37ca22dd79ec213474edc.jpg";